export default __webpack_public_path__ + "static/media/IF_MyTeamStrengths_StrengthDesc_01.dd6e18e8.jpg";